import React from 'react';
import "./ImgContextMenuIcons.scss"

const WidthFullSVG = () => {
	return (
		<svg className="horiz-context-menu-icon"  xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path fill="#1A2038" d="M172.31-180q-29.92 0-51.12-21.19Q100-222.39 100-252.31v-455.38q0-29.92 21.19-51.12Q142.39-780 172.31-780h615.38q29.92 0 51.12 21.19Q860-737.61 860-707.69v455.38q0 29.92-21.19 51.12Q817.61-180 787.69-180H172.31Zm0-60h36.15v-480h-36.15q-5.39 0-8.85 3.46t-3.46 8.85v455.38q0 5.39 3.46 8.85t8.85 3.46Zm96.15 0h423.08v-480H268.46v480Zm483.08 0h36.15q5.39 0 8.85-3.46t3.46-8.85v-455.38q0-5.39-3.46-8.85t-8.85-3.46h-36.15v480ZM268.46-720v480-480Z" /></svg>
	);
}

export default WidthFullSVG;